import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Mail, CheckCircle, AlertCircle } from 'lucide-react';

const EmailSubscription = ({ 
  placeholder = "Enter your email address", 
  buttonText = "Subscribe",
  source = "website",
  className = "",
  onSuccess = null 
}) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch('/api/emails/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          source: source
        }),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('Successfully subscribed! Thank you for joining us.');
        setEmail('');
        if (onSuccess) onSuccess(email);
      } else {
        const errorData = await response.json();
        setStatus('error');
        setMessage(errorData.detail || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Network error. Please check your connection and try again.');
    }
  };

  return (
    <div className={`w-full ${className}`}>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <Input
            type="email"
            placeholder={placeholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full"
            required
            disabled={status === 'loading'}
          />
        </div>
        <Button 
          type="submit" 
          disabled={status === 'loading' || !email}
          className="bg-[#D4623C] hover:bg-[#B8532F] text-white font-semibold px-6 py-2.5 transition-all duration-300"
        >
          {status === 'loading' ? (
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Subscribing...</span>
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <Mail size={16} />
              <span>{buttonText}</span>
            </div>
          )}
        </Button>
      </form>
      
      {message && (
        <div className={`mt-3 flex items-center space-x-2 text-sm ${
          status === 'success' ? 'text-green-600' : 'text-red-600'
        }`}>
          {status === 'success' ? (
            <CheckCircle size={16} />
          ) : (
            <AlertCircle size={16} />
          )}
          <span>{message}</span>
        </div>
      )}
    </div>
  );
};

export default EmailSubscription;

